import { render, staticRenderFns } from "./ParametrosSistema.vue?vue&type=template&id=9b635c6e&scoped=true&"
import script from "./ParametrosSistema.vue?vue&type=script&lang=js&"
export * from "./ParametrosSistema.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosSistema.vue?vue&type=style&index=0&id=9b635c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b635c6e",
  null
  
)

export default component.exports